import React from 'react'
import styled from 'styled-components'

import { colors, media } from 'styles'
import { T } from 'components'

const StyledError = styled.div`
  display: flex;
  width: 100vw;
  height: 100vh;
  background: #fff url(${() => require('assets/images/hannah-working.jpg')}) left / contain no-repeat;
  p {
    max-width: 70rem;
    font-size: 2.4rem;
    margin: auto;
    margin-left: 30%;
    text-align: center;
    line-height: 1.3;
    padding: 1rem;
    strong {
      font-size: 3.8rem;
      display: block;
      color: ${colors.highlight};
      margin-bottom: 2rem;
    }
  }
  ${media.mobile`
    background-position: bottom center;
    background-size: 290px;
    p {
      margin: 2rem auto 0;
      font-size: 1.6rem;
      strong {
        font-size: 3rem;
      }
    }
  `}
`

const Error = () => (
  <StyledError>
    <T as="p" label="messages/serverError|basicHTML" />
  </StyledError>
)

export default Error
